import { render, staticRenderFns } from "./AccessManagementEdit.vue?vue&type=template&id=3bd27aab&"
import script from "./AccessManagementEdit.vue?vue&type=script&lang=js&"
export * from "./AccessManagementEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports